import { isBusinessOpen, primaryProperty, useGetAllBusinesses } from "@api/businessService";
import { useEffect, useState } from "react";
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import ObjectIndex from "@components/objects/ObjectIndex";
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { formatDate, isValidDate } from "@utils/dates";
import { useGetAllProperties } from "@api/propertyService";

import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import DirectionsRoundedIcon from '@mui/icons-material/DirectionsRounded';
import { useGetAllOpportunities } from "@api/opportunityService";
import { useCopyToClipboard } from "@uidotdev/usehooks";
import { Button } from "@mui/joy";
import toast from "react-hot-toast";
import { formatCurrency } from "@utils/numbers";
import { useDeleteDonation, useGetAllDonations } from "@api/donationService";
import { CheckPermission } from "@components/CheckPermission";


const columns = [
    {
        id: 'id',
        numeric: true,
        disablePadding: true,
        sortable: true,
        label: 'Donor',
        cell: (row, {LinkComponent}) => {
            return (<>
                <LinkComponent to={`${row.id}`} relative={true} object={row}>
                    <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>
                        {!!row.anonymous && (<>
                            Anonymous
                            <CheckPermission permissions={'view donations'}>
                            {` (${row.donor?.name})`}
                            </CheckPermission>
                        </>)}

                        {!row.anonymous && (<>{row.donor?.name ?? '(Deleted Donor)'}</>)}
                    </Typography>
                </LinkComponent>
            </>)
        }
    },
    {
        id: 'type',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Type',
        cell: (row) => row.type
    },
    {
        id: 'amount',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Amount',
        cell: (row) => formatCurrency(row.amount)
    },
    {
        id: 'dates',
        numeric: false,
        disablePadding: false,
        sortable: false,
        label: 'Date(s)',
        cell: (row) => (<>
            {isValidDate(row.start_date) && (<span>{formatDate(row.start_date)}</span>)}
            {isValidDate(row.start_date) && row.start_date != row.end_date && isValidDate(row.end_date) && (<>{' - '}</>)}
            {row.start_date != row.end_date && isValidDate(row.end_date) && (<span>{formatDate(row.end_date)}</span>)}
        </>)
    },
];

const listCell = (row, {LinkComponent}) => {
    return (<>
        <Box sx={{mb: 1}}>
            <Typography sx={{display: 'inline-block'}} fontWeight={'bold'}>
                <LinkComponent to={`${row.id}`} relative={true} object={row}>
                    {!!row.anonymous && (<>
                        Anonymous
                        <CheckPermission permissions={'view donations'}>
                        {` (${row.donor?.name})`}
                        </CheckPermission>
                    </>)}

                    {!row.anonymous && (<>{row.donor?.name ?? '(Deleted Donor)'}</>)}
                </LinkComponent>
            </Typography>
            <Typography fontSize="sm">{row.amount}</Typography>
        </Box>
    </>);
};

/*
const listActions = (row, {view, LinkComponent, ViewAction}) => {
    if(view === 'deleted') {
        return null;
    }

    return (<>
        {/* <CopyLinkButton opportunity={row} includeText={false} /> *\/}
    </>);
};
*/
export default function DonationIndex() {
    return (
        <ObjectIndex
            defaultParams={{orderby: 'id'}}
            query={useGetAllDonations}
            deleteMutation={useDeleteDonation}
            type={'donation'}
            permissionType={'donations'}
            title={'Donations'}
            color={'default'}
            columns={columns}
            listCell={listCell}
            // listActions={listActions}
        />
    )
}
